import React from 'react';
import { Layout, Table, Typography, Card, Button, Space, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { HomeOutlined, UserAddOutlined } from '@ant-design/icons';

import ClientHeader from '../components/header';
import ClientFooter from '../components/footer';
import ClientSider from '../components/sider';
import AdminAndUserModal from '../components/AdminAndUserModal';

import {
  fetchAdminUser,
  addAdminUser,
  updateAdminUser,
  deleteAdminUser,
} from '../store/adminUserAction';

const { Content } = Layout;
const { Title } = Typography;

class AdminAwsUserList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      setModal: {
        adminUserEdit: {},
        btnAction: '',
        modalTitle: '',
        role: null
      },
      showAdminUserModal: false,
      errorMessage: ''
    };
  }

  componentDidMount() {
    this.props.fetchAdminUser();
  }

  handleApiResult(){
    if (this.props.status === 'success') {
      alert(this.props.message);
      this.toggleModal();
    }else {
      this.setState({
        errorMessage: this.props.message
      });
    }
  }

  handleBtnAction = (action, record) => {
    this.setState({ errorMessage: '' });
    const adminUserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    switch (action) {
      case "EditBtn":
        this.setState({
          setModal: {
            adminUserEdit: record,
            modalTitle: 'Edit Backend User',
            btnAction: action,
            role: adminUserInfo.role
          }
        });
        this.toggleModal();
        break;
      case "AddBtn":
        this.setState({
          setModal: {
            adminUserEdit: {},
            modalTitle: 'Create an User Account',
            btnAction: action,
            role: adminUserInfo.role
          }
        });
        this.toggleModal();
        break;
      case 'DelBtn':
        this.handleDelete(record)
        break;
      default:
        console.warn("未知handleBtnAction")
    }
  }

  handleDelete = async (data) => {
    await this.props.deleteAdminUser(data);
    if (this.props.status === 'success') {
      alert(this.props.message);
    }
    await this.props.fetchAdminUser();
  }

  handleModalForm = async (data) => {
    const { btnAction } = this.state.setModal;
    switch (btnAction) {
      case "EditBtn":
        await this.props.updateAdminUser(data);
        break;
      case "AddBtn":
        await this.props.addAdminUser(data);
        break;
      default:
        console.warn("未知handleModalForm")
    }
    this.handleApiResult();
    await this.props.fetchAdminUser();
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      showAdminUserModal: !prevState.showAdminUserModal
    }));
  }

  render() {
    const adminUserInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const columns = [
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: 'User Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Create Date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at)
      },
      {
        title: 'Update Date',
        dataIndex: 'updated_at',
        key: 'updated_at',
        sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
      },
      {
        title: 'Manage',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, record) => {
          const isAdmin = adminUserInfo?.role === 1
          const isSelf = adminUserInfo?.account === record.account
          return isAdmin ? (
            <Space size="middle">
              <Button type="primary"
                ghost
                onClick={() => this.handleBtnAction('EditBtn', record)}
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete Backend User"
                description="Are you sure you want to delete ?"
                showCancel={false}
                onConfirm={() => this.handleBtnAction('DelBtn', record)}
                okText="confirm"
              >
                <Button danger disabled={record.role===1}>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          ) : isSelf ? (<Button type="primary" ghost onClick={() => this.handleBtnAction('EditBtn', record)}>Edit</Button>) : (<></>)
        }
      },
    ];

    return (
      <Layout style={{ minHeight: '100vh' }}>
        <ClientSider />
        <Layout>
          <ClientHeader />
          <Content style={{ margin: '24px 16px 0' }}>
            <Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={3} style={{ marginBottom: '1rem' }}>
                  <HomeOutlined style={{ marginRight: 8 }} />
                  Backend User Managed
                </Title>
                {adminUserInfo?.role === 1 && (
                  <Button type="primary" onClick={() => this.handleBtnAction('AddBtn', '')}><UserAddOutlined />Create Login Account</Button>
                )}
              </div>
              <Table
                dataSource={this.props.AdminUserList}
                rowKey="id"
                columns={columns}
                bordered
                pagination={{ pageSize: 15 }}
                showSorterTooltip={false} // 關閉所有排序提示
              />
            </Card>

            <AdminAndUserModal
              visible={this.state.showAdminUserModal}
              onClose={this.toggleModal}
              onSubmit={this.handleModalForm}
              modalData={this.state.setModal}
              errorMessage={this.state.errorMessage}
            />
          </Content>
          <ClientFooter />
        </Layout>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  AdminUserList: state.adminUser.AdminUserList,
  status: state.adminUser.status,
  message: state.adminUser.message
});

const mapDispatchToProps = {
  fetchAdminUser,
  addAdminUser,
  updateAdminUser,
  deleteAdminUser
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminAwsUserList);